export const isHebrew = (str: string) => /[\u0590-\u05FF]/.test(str);
